// Секунд тоолуур. Таб идэвхгүй үед setInterval удааширдаг тул дуусах цагаас тооцно.
// onTick(үлдсэн секунд)-ийг шууд болон секунд тутам дуудна. Зогсоох функц буцаана.
export function startCountdown(seconds, onTick) {
  const endAt = Date.now() + Math.ceil(Number(seconds) || 0) * 1000;
  let timer = null;
  const stop = () => {
    if (timer) clearInterval(timer);
    timer = null;
  };
  const tick = () => {
    const left = Math.max(0, Math.ceil((endAt - Date.now()) / 1000));
    onTick(left);
    if (left === 0) stop();
    return left;
  };
  if (tick() > 0) timer = setInterval(tick, 1000);
  return stop;
}

// 190 -> "03:10"
export function formatMmSs(totalSeconds) {
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}
